<template>
    <div class="row h-100">
        <div
            class="col-5 algolia-listing-product-block__product-pricing-wrapper px-0"
        >
            <div
                class="algolia-listing-product-block__product-price algolia-listing-product-block__product-price--unavailable"
            >
                {{ combination.price_for_display }}
            </div>
        </div>
        <div
            class="col-7 algolia-listing-product-block__product-unavailable-wrapper px-0"
        >
            <div
                v-if="combination.unavailable_status_text"
                class="algolia-listing-product-block__product-unavailable-note"
                :class="getUnavailableClass"
                v-html="combination.unavailable_status_text"
            >
            </div>
            <div
                v-else
                class="algolia-listing-product-block__product-unavailable-note"
            >
                 <span v-html="$t('algoliaSearch.unAvailableNotePartOne')">
                </span>
                <span
                    class="algolia-listing-product-block__product-unavailable-note--date"
                >{{ formattedDate }}</span
                >
                <br />
                <span>
                    {{ $t("algoliaSearch.unAvailableNotePartTwo") }}
                </span>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: "PricingNotAvailable",
    props: {
        combination: {
            type: Object,
            required: true
        },
        langIso: {
            type: String,
            required: false,
            default: 'nl-NL',
        },
    },
    computed: {
        formattedDate() {
            if (this.combination.available_date_in_future) {
                let LangIso = this.langIso;
                const date = new Date(this.combination.available_date_in_future);

                if (this.langIso === 'se') {
                    LangIso = 'sv';
                }

                return date.toLocaleDateString(LangIso, {month: 'long', day: 'numeric'})
            }

            return "14 aug";
        },
        getUnavailableClass() {
            switch(this.combination.unavailable_status) {
                case 'temporary_not_available':
                    return 'text--orange';
                case 'not_available':
                    return 'text--red-400';
                case 'available_soon':
                    return 'text--green-400';
            }
        }

    }
};
</script>
